module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/ffa-bg-01-662d1b4188f272cd137bdf0e8720b6ca.webp";